import React from 'react';

import cx from 'classnames';

import Icon from 'components/shared/Icon';
import Plus from 'components/shared/Icon/icons/Plus';

import s from './index.module.css';
import { IBluePlusButtonProps } from './types';

function BluePlusButton({ className }: IBluePlusButtonProps) {
  return <Icon component={Plus} className={cx(s.icon, className)} />;
}

export default BluePlusButton;
